export class LayerSource {
  id: number;

  name?: string;

  key?: string;

  username?: string;

  password?: string;

  url?: string;

  templateUrl?: string;

  minResolution?: number;

  maxResolution?: number;

  viewParams?: string;

  orientations?: string[];

  features?: any;

  epsg?: string;

  additionalConfig?: any;

  /** Band value stretch bounds (GeoTIFF layers) — the real data range, excluding nodata sentinels. */
  min?: number;

  /** Band value stretch bounds (GeoTIFF layers) — the real data range, excluding nodata sentinels. */
  max?: number;

  /** Sentinel value to render as transparent (GeoTIFF layers). */
  nodata?: number;

  /**
   * Raw file bytes (GeoTIFF layers) — persisted to IndexedDB so the layer survives a page reload,
   * and read directly by the map's GeoTIFF layer (no network request, unlike `url`).
   */
  blob?: Blob;
}
